import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const CaseAccessDenied: React.FC = () => {
  const permissions = useSelector((state: any) => state.permissions);
  const { t } = useTranslation();
  return (
    <div className="case-access-denied">
      <div className="motif-h1">
        {permissions?.validCaseId
          ? t("global.globalNotifications.noCasePermission")
          : t("global.globalNotifications.caseIdNotValid")}
      </div>
    </div>
  );
};

export default CaseAccessDenied;
